var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlueCircleWhatsappIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_27",
    "data-name": "Ellipse 27",
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    fill: "#4bca59"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "whatsapp",
    d: "M10.519,1.755A5.987,5.987,0,0,0,1.1,8.977l-.849,3.1,3.173-.832a5.979,5.979,0,0,0,2.86.729h0a5.988,5.988,0,0,0,4.234-10.22ZM6.285,10.964h0a4.969,4.969,0,0,1-2.532-.693l-.182-.108-1.883.494.5-1.836-.118-.188a4.975,4.975,0,1,1,4.214,2.331ZM9.014,7.238c-.15-.075-.885-.437-1.022-.487s-.237-.075-.336.075-.386.487-.474.586-.174.112-.324.037a4.085,4.085,0,0,1-1.2-.742,4.511,4.511,0,0,1-.832-1.036c-.087-.15,0-.223.066-.305a4.23,4.23,0,0,0,.374-.512.275.275,0,0,0-.013-.262c-.037-.075-.336-.811-.461-1.11s-.245-.252-.337-.257-.187-.005-.287-.005a.549.549,0,0,0-.4.187,1.677,1.677,0,0,0-.523,1.248A2.909,2.909,0,0,0,3.855,6.2,6.666,6.666,0,0,0,6.41,8.461a8.56,8.56,0,0,0,.853.315,2.05,2.05,0,0,0,.942.059,1.541,1.541,0,0,0,1.009-.711A1.25,1.25,0,0,0,9.3,7.413c-.037-.062-.137-.1-.287-.175Zm0,0",
    transform: "translate(6.75 7)",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueCircleWhatsappIcon);
export default __webpack_public_path__ + "static/media/BlueCircleWhatsappIcon.69135986.svg";
export { ForwardRef as ReactComponent };